/**
 * Fitness test metadata — shared between Convex backend and frontend.
 * No Convex-specific imports so this file is safe to import from both sides.
 */

export interface TestMeta {
  label: string;
  unit: string;
  /** true = higher score is better (e.g. beep test level, jump distance)
   *  false = lower score is better (e.g. sprint time) */
  higherIsBetter: boolean;
}

export const FITNESS_TEST_META: Record<string, TestMeta> = {
  beep_test:     { label: "Beep Test",       unit: "level",   higherIsBetter: true  },
  sprint_30m:    { label: "30m Sprint",      unit: "seconds", higherIsBetter: false },
  t_test:        { label: "T-Test Agility",  unit: "seconds", higherIsBetter: false },
  "4_corner":    { label: "4-Corner Drill",  unit: "seconds", higherIsBetter: false },
  broad_jump:    { label: "Broad Jump",      unit: "cm",      higherIsBetter: true  },
  vertical_jump: { label: "Vertical Jump",   unit: "cm",      higherIsBetter: true  },
  pushups:       { label: "Push-ups",        unit: "reps",    higherIsBetter: true  },
  situps:        { label: "Sit-ups",         unit: "reps",    higherIsBetter: true  },
  cooper:        { label: "Cooper Run",      unit: "metres",  higherIsBetter: true  },
};

/** Standard (non-custom) test types in display order. */
export const STANDARD_TEST_TYPES = Object.keys(FITNESS_TEST_META) as Array<
  keyof typeof FITNESS_TEST_META
>;

/**
 * Returns age in whole years at a given YYYY-MM-DD date.
 * Returns null if dateOfBirth is absent/null/undefined.
 */
export function ageAtDate(
  dateOfBirth: string | null | undefined,
  testDate: string
): number | null {
  if (!dateOfBirth) return null;
  const birth = new Date(dateOfBirth);
  const test = new Date(testDate);
  let age = test.getFullYear() - birth.getFullYear();
  const m = test.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && test.getDate() < birth.getDate())) age--;
  return age;
}
